import { takeEvery } from 'redux-saga'
import { put, select, call, all } from 'redux-saga/effects'
import { DESTROY_MULTI_IMAGER } from 'actions/multiImagerActionTypes'
import { destroyCameraSelector } from 'selectors'
import { removeMultiImagerAction } from 'actions/multiImagerActions'
import { updatePresentationValuesAction } from 'actions/presentationActions'
import { removeDeviceWiresAction } from 'actions/entityActions'
import { notifyHoneybadgerAction } from 'actions/applicationActions'
import chooseProperCameraToShift from 'helpers/cameras/chooseProperCameraToShift'
import findById from 'helpers/findById'

/** Remove multi imager and set previous camera to current camera */
export function* destroyMultiImager(action) {
  try {
    const { cameraIds, cameras } = yield select(destroyCameraSelector)
    const { id } = action

    const camera = findById({ state: cameras, id })
    const { lensIds } = camera

    yield put(removeDeviceWiresAction(id, 'camera'))

    // remove multi imager and lenses from map
    yield call(camera.remove)
    yield all(lensIds.map(lensId => call(findById({ state: cameras, id: lensId }).remove)))

    const idToSwitchTo = chooseProperCameraToShift({ cameraIds: cameraIds.filter(i => !lensIds.includes(i)), id })

    yield put.resolve(removeMultiImagerAction(id, lensIds, idToSwitchTo))
    if (cameras.length > lensIds.length + 1) yield put(updatePresentationValuesAction())
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, action))
  }
}

/** Watch for destroy multi imager action, then call function */
export function* watchDestroyMultiImager() {
  yield* takeEvery(DESTROY_MULTI_IMAGER, destroyMultiImager)
}



// WEBPACK FOOTER //
// ./src/sagas/destroyMultiImagerSaga.js